<!-- 搜索组件 -->
<template>
    <div v-if="componentsData.type == -1">
        <div class="display-flex w100" :style="`padding: ${componentsData.content.marginData.top}px ${componentsData.content.marginData.left}px;`">
            <div class="flex-1 pl-6"
                :style="`
                    border: 1px solid ${componentsData.content.border_color}; text-align: ${componentsData.content.position};
                    height: ${componentsData.content.height}px; line-height: ${componentsData.content.height}px; background: ${componentsData.content.bg_color};
                    border-radius: ${componentsData.content.marginData.radius}px 0 0 ${componentsData.content.marginData.radius}px;
                `"
            >
                <span class="fs-12" :style="`color:${componentsData.content.text_color};`">
                    {{componentsData.content.text ? componentsData.content.text : "请输入提示文字"}}
                </span>
            </div>
            <div class="flex-c"
                :style="`
                    width: ${componentsData.content.height}px; height: ${componentsData.content.height}px;
                    border: 1px solid ${componentsData.content.bgs_color}; background: ${componentsData.content.bgs_color};
                    border-radius: 0 ${componentsData.content.marginData.radius}px ${componentsData.content.marginData.radius}px 0;
                `"
            >
                <img class="w20" :src="componentsData.content.imgs.picview"/>
            </div>
        </div>
        <div :style="`padding: ${componentsData.content.marginData.btn_top_bottom}px ${componentsData.content.marginData.btn_left_right}px;`">
            <button class="w100 overflow-hidden"
                :style="`
                    height: ${componentsData.content.btn_height}px; line-height: ${componentsData.content.btn_height}px;
                    background: ${componentsData.content.btn_bg_color}; border: 1px solid ${componentsData.content.btn_border_color};
                    border-radius: ${componentsData.content.marginData.btn_radius}px;
                `"
            >
                <span class="color-fff">{{componentsData.content.btn_text}}</span>
            </button>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        componentsData: {
            type: Object,
            default: {},
        },
    },
    data() {
        return {
        }
    },
    mounted(){
    },
    methods: {
    },
};
</script>

<style scoped>
.display-flex {
    display: flex;
}
.w100 {
    width: 100%;
}
.w20 {
    width: 20px;
    height: 20px;
}
.flex-1 {
    flex: 1;
}
.pl-6 {
    padding: 0 0 0 6px;
}
.fs-12 {
    font-size: 12px;
}
.overflow-hidden {
    overflow: hidden;
}
.color-fff {
    color: #fff;
}
</style>